
import React from "react";

export function EmptyWorkout() {
  return (
    <div className="p-4 text-center text-white/70 border border-white/10 rounded-md">
      No exercises for this day. This might be a rest day or recovery session.
    </div>
  );
}
